"use client";

import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP);
export default function Chemicalprocessinghero() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".pd-eyebrow", {
        y: 16
      });
      gsap.set(".pd-heading", {
        y: 24
      });
      gsap.set(".pd-sub", {
        y: 16
      });
      gsap.set(".pd-link", {
        y: 12
      });
      gsap.set(".pd-aurora", {
        scale: 0.9
      });
      const tl = gsap.timeline({
        defaults: {
          ease: "power3.out",
          duration: 0.72
        }
      });
      tl.to(".pd-aurora", {
        opacity: 0.08,
        scale: 1,
        duration: 1.4
      }, 0).to(".pd-eyebrow", {
        opacity: 1,
        y: 0
      }, 0.1).to(".pd-heading", {
        opacity: 1,
        y: 0
      }, 0.2).to(".pd-sub", {
        opacity: 1,
        y: 0
      }, 0.3).to(".pd-link", {
        opacity: 1,
        y: 0
      }, 0.4);
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".pd-eyebrow", ".pd-heading", ".pd-sub", ".pd-link"], {
        opacity: 1,
        y: 0
      });
      gsap.set(".pd-aurora", {
        opacity: 0.08,
        scale: 1
      });
    });
  }, {
    scope: container
  });
  return <section data-section-id="31256" id="chemicalprocessinghero" data-nav="dark" className="relative overflow-hidden bg-background text-foreground py-32 md:py-56 min-h-[80vh] flex items-center">
      {}
      <div className="pd-aurora pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[1100px] h-[1100px] max-w-none" style={{
      opacity: 0,
      background: "radial-gradient(ellipse at center, hsl(215 80% 20%) 0%, hsl(215 90% 45%) 35%, hsl(210 20% 98% / 0) 70%)",
      filter: "blur(40px)"
    }} aria-hidden="true" />

      <div ref={container} className="relative mx-auto w-full max-w-[1360px] px-6 md:px-10 lg:px-16">
        <div className="flex flex-col items-center text-center">
          {}
          <div className="pd-eyebrow flex items-center justify-center gap-3" style={{
          opacity: 0
        }}>
            <span aria-hidden="true" className="inline-block h-px w-6" style={{
            backgroundColor: "hsl(215 90% 45%)"
          }} />
            <span className="font-default text-[11px] md:text-xs font-medium uppercase leading-none" style={{
            letterSpacing: "0.22em",
            color: "hsl(215 90% 45%)"
          }}>
              {"Engenharia \u00B7 Pulverização"}
            </span>
          </div>

          {}
          <h1 className="pd-heading font-default text-foreground mt-16 md:mt-24 max-w-[22ch] font-normal" style={{
          opacity: 0,
          fontSize: "clamp(3rem, 8.4vw, 9.25rem)",
          lineHeight: 0.94,
          letterSpacing: "-0.035em",
          fontWeight: 450
        }}>
            Especialistas em Pulverização Industrial.
          </h1>

          {}
          <p className="pd-sub font-default mt-12 md:mt-16 max-w-[42ch]" style={{
          opacity: 0,
          fontSize: "clamp(1.0625rem, 1.15vw, 1.25rem)",
          lineHeight: 1.55,
          letterSpacing: "-0.005em",
          fontWeight: 350,
          color: "hsl(215 12% 40%)"
        }}>
            Representantes exclusivos da Spraying Systems Co. desde 1993.
          </p>

          {}
          <div className="pd-link mt-8 md:mt-10" style={{
          opacity: 0
        }}>
            <Link to="/ContactsPage" className="group inline-flex items-center gap-2 font-default text-[15px] font-normal text-foreground transition-colors duration-300">
              <span className="border-b border-transparent group-hover:border-current transition-colors duration-300" style={{
              borderColor: "transparent"
            }}>
                Consulte-nos hoje
              </span>
              <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-0.5" style={{
              color: "hsl(215 90% 45%)"
            }} strokeWidth={1.25} aria-hidden="true" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}